import { Box, IconButton, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import React from 'react';

interface CellHilTemplateActionsProps {
  params: any;
  onClick: (
    params: any,
    clickedElement: 'edit' | 'preview' | 'approve' | 'reject' | 'delete',
  ) => void;
}

const CellHilTemplateActions = ({
  params,
  onClick,
}: CellHilTemplateActionsProps) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <Tooltip title="Edit">
        <IconButton
          size="small"
          aria-label="edit"
          onClick={(e) => {
            e.stopPropagation();
            onClick(params, 'edit');
          }}
          sx={{ padding: 0.5 }}
        >
          <EditIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Tooltip title="Approve">
        <IconButton
          size="small"
          aria-label="approve"
          onClick={(e) => {
            e.stopPropagation();
            onClick(params, 'approve');
          }}
          sx={{ padding: 0.5, color: 'success.main' }}
        >
          <CheckIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Tooltip title="Reject">
        <IconButton
          size="small"
          aria-label="reject"
          onClick={(e) => {
            e.stopPropagation();
            onClick(params, 'reject');
          }}
          sx={{ padding: 0.5 }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Tooltip title="Preview">
        <IconButton
          size="small"
          aria-label="preview"
          onClick={(e) => {
            e.stopPropagation();
            onClick(params, 'preview');
          }}
          sx={{ padding: 0.5 }}
        >
          <VisibilityOutlinedIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Tooltip title="Delete">
        <IconButton
          size="small"
          aria-label="delete"
          onClick={(e) => {
            e.stopPropagation();
            onClick(params, 'delete');
          }}
          sx={{ padding: 0.5 }}
        >
          <DeleteOutlineIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default CellHilTemplateActions;
